import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const disasterDeliveryDetailRepository = RepositoryFactory.get(
  "disasterDeliveryDetail"
);

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setDisasterDeliveryDetail(state, payload) {
    state.data = payload;
  }
};
const actions = {
  async loadDisasterDeliveryDetail(context, payload) {
    const list = await disasterDeliveryDetailRepository.list(
      payload.screenId,
      payload.deliveryNo
    );
    if (list.status < 300) {
      context.commit("setDisasterDeliveryDetail", list.data);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
